import { render, staticRenderFns } from "./FormVacancy.vue?vue&type=template&id=2f027433"
import script from "./FormVacancy.vue?vue&type=script&lang=js"
export * from "./FormVacancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports